import { useEffect, useState, useRef } from "react";
import { getDocumentRetrievalQuestionSuggestions, serverUrl } from "../../data/dataApi";
import { checkInconclusiveResponse, cleanMessage } from "../helpers";
import {
    pathToFileName,
    makePdfUrl,
    markdownToHtml
} from "../../scripts/utils";
import MessageActions from "./MessageActions";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Message = ({ message, messageIndex, messages, setMessages, setMessageKey, sessionInfo, feedbackDetails, onFeedbackDetailsChange, onFeedbackOpen, onChatError, disableInput, onSubmit, setQuery, loading, userEmail, botType }) => {
    let icon;

    if (message.type === 'apiMessage' || message.type === 'supportMessage') {
        icon = (
            <img src={`${serverUrl}/static/assets/gelest-chatbot-widget-logo.svg`} className={`message-user-img flex-shrink-0 d-md-block d-none ${message.type === "supportMessage" ? "support-message-img" : ""}`} alt="Gelest chatbot logo" />
        );
    } else {
        icon = (
            <img src={`${serverUrl}/static/assets/user-icon.svg`} className="message-user-img d-md-block d-none flex-shrink-0" alt="User icon" />
        );
    }

    useEffect(() => {
        (async () => {
            if (messages.length <= 1 && botType === "document_retrieval" && !messages[0].suggestions.length) {
                const response = await getDocumentRetrievalQuestionSuggestions();

                if (response.success) {
                    setMessages((prevMessages) => {
                        const updatedMessages = [...prevMessages];
                        updatedMessages[0].suggestions = response.data.rows[0]?.questions.questions;
                        return updatedMessages;
                    });
                }
            }
        })();
    }, [sessionInfo]);

    if (!message.message) return null;

    console.log('[Message Component] message.products:', message.products);

    return (
        <div className={`message-wrapper overflow-hidden tif-px-md-0 tif-px-15 ${message.type === 'userMessage' ? 'user-message tif-bg-color-yankee tif-py-md-30 tif-py-15' : 'api-message tif-pt-md-35 tif-pt-20 tif-pb-md-45 tif-pb-25'} ${message.type === "supportMessage" ? "support-message" : ""}`}>
            <div className="message-container d-flex align-items-start tif-mx-auto">
                {icon}
                <div className="message flex-grow-1">
                    <div className={`message-text d-flex justify-content-between ${message.sourceDocs ? 'has-source-docs tif-pt-30' : ''} ${message.type === "supportMessage" ? "support-text tif-pt-40" : ""}`}>
                        <div>
                            {
                                message.type === "supportMessage" &&
                                <p className="support-message-title tif-mb-15 fw-bold">Not getting the answers you need?</p>
                            }
                            {message.replyText && message.type === 'userMessage' && (
                                <div className="user-message-reply-context d-flex align-items-start tif-mb-10">
                                    <svg className="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" strokeLinejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-back"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1" /></svg>
                                    <span className="reply-quote">"{message.replyText}"</span>
                                </div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: markdownToHtml(cleanMessage(message.message), message.type === "apiMessage") }} />
                            {
                                (message.suggestions?.length && messages.length === 1 && !loading && !disableInput) ? (
                                    <>
                                        <p className="gcw-suggestions-title">Suggestions:</p>
                                        <ul className="gcw-suggestions">
                                            {
                                                message.suggestions.map((suggestion, index) => (
                                                    <li key={index} onClick={() => onSubmit(null, suggestion)}>{suggestion}</li>
                                                ))
                                            }
                                        </ul>
                                    </>
                                ) : null
                            }
                        </div>
                    </div>
                    {message.pdfSourceDocs && message.pdfSourceDocs.length ? (
                        <>
                            <p className="sources-title">Brochure/Catalog Sources:</p>
                            <ul className="sources">
                                {message.pdfSourceDocs.map((doc, index) => (
                                    doc.metadata.source &&
                                    <li key={`messageSourceDocs-${index}`}>
                                        <a href={makePdfUrl(doc.metadata.source)} target="_blank">
                                            <img src={`${serverUrl}/static/assets/pdf-icon.svg`} alt="PDF icon" className="pdf-icon" />
                                            {pathToFileName(doc.metadata.source)}
                                            <img src={`${serverUrl}/static/assets/arrow-icon.svg`} alt="Arrow icon" className="arrow-icon" />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : <></>}

                    {
                        (message.productPdfs && message.productPdfs.length && !checkInconclusiveResponse(message.message)) ?
                            <>
                                <p className="sources-title">Source Documents:</p>
                                <ul className="sources">
                                    {message.productPdfs.map((doc, index) => (
                                        doc &&
                                        <li key={`messageSourceDocs-${index}`}>
                                            <div className="source-title">
                                                <img src={`${serverUrl}/static/assets/pdf-icon.svg`} alt="PDF icon" className="pdf-icon" />
                                                <span>{doc.title}</span>
                                                <img src={`${serverUrl}/static/assets/arrow-icon.svg`} alt="Arrow icon" className="arrow-icon" />
                                            </div>
                                            <a href={doc.sourceUrl} className="stretched-link" target="_blank"></a>
                                        </li>
                                    ))}
                                </ul>
                            </>
                            :
                            <></>
                    }

                    {(message.productUrls && message.productUrls.length) ? (
                        <>
                            <p className="sources-title">Source Links:</p>
                            <ul className="sources">
                                {message.productUrls.map((doc, index) => (
                                    <li key={`messageSourceDocs-${index}`}>
                                        <div className="source-title">
                                            <img src={`${serverUrl}/static/assets/link-icon.svg`} alt="Link icon" className="link-icon" />
                                            <span>{doc?.title}</span>
                                            <img src={`${serverUrl}/static/assets/arrow-icon.svg`} alt="Arrow icon" className="arrow-icon" />
                                        </div>
                                        <a href={doc?.sourceUrl} className="stretched-link" target="_blank"></a>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : <> </>}

                    {(message.products && message.products.length) ? (
                        <div className="product-suggestions tif-py-30">
                            <Swiper
                                modules={[Navigation, Pagination]}
                                spaceBetween={10}
                                slidesPerView={1.5}
                                pagination={{ clickable: true }}
                                breakpoints={{
                                    640: {
                                        slidesPerView: 1.5,
                                    },
                                    768: {
                                        slidesPerView: 2.5,
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                    },
                                }}
                                className="products-swiper"
                            >
                                {message.products.filter(product => product.url && product.sku).map((product, index) => (
                                    <SwiperSlide key={`product-${index}`}>
                                        <div className="product-card position-relative">
                                            <div className="product-image tif-mb-10">
                                                <img src={product.image || "https://www.gelest.com/wp-content/uploads/new-placeholder-1.png"} className="w-100" alt={product.title} />
                                            </div>
                                            <a href={product.url} target="_blank" className="product-sku stretched-link">{product.sku}</a>
                                            <p className="product-title tif-font-xs tif-mb-0">{product?.title}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    ) : <></>}

                    {(message.followUpQuestions && message.followUpQuestions.length && !loading && !disableInput) ? (
                        <div className="follow-up-questions tif-mt-30">
                            <ul className="gcw-question-suggestions list-unstyled">
                                {message.followUpQuestions.map((question, index) => (
                                    <li key={`followup-${index}`} onClick={() => onSubmit(null, question)}>{question}</li>
                                ))}
                            </ul>
                        </div>
                    ) : <></>}

                    {
                        feedbackDetails ?
                            (message.type === "apiMessage" && (messageIndex < messages.length - 1 || messageIndex == messages.length - 1) && !disableInput && messageIndex !== 0) && (
                                <MessageActions message={message} messageIndex={messageIndex} messages={messages} setMessages={setMessages} sessionInfo={sessionInfo} feedbackDetails={feedbackDetails} onChatError={onChatError} setMessageKey={setMessageKey} onFeedbackDetailsChange={onFeedbackDetailsChange} onFeedbackOpen={onFeedbackOpen} userEmail={userEmail} onSubmit={onSubmit} setQuery={setQuery} />
                            )
                            :
                            <></>
                    }
                </div>
            </div>
        </div>
    );
};

export default Message;